// import { Actions } from "../actions/types";
// import update from "immutability-helper";

const initialState = {

};

export const main = (state = initialState, { type, payload }) => {
  switch (type) {


    default:
      return state;
  }
};
